module.exports = __webpack_public_path__ + "img/LBA-Settings.c7f5817d.svg";